import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CloseDialogDirective } from './close-dialog.directive';
import { DialogDirective } from './dialog.directive';



@NgModule({
    declarations: [DialogDirective, CloseDialogDirective],
    imports: [
        CommonModule
    ],
    exports: [DialogDirective, CloseDialogDirective]
})
export class DialogModule {}
